"use client";
import { useEffect, useState } from "react";
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined, MenuOutlined, YoutubeOutlined } from "@ant-design/icons";

export const MobileMenu = ({ children, siteMap, isHomePage, isInventory }: { children: React.ReactNode; siteMap: any; isHomePage: boolean; isInventory: boolean }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileMenuOpen]);

    const onMobileMenuClick = () => { setMobileMenuOpen((prev: boolean) => !prev); };

    return (
        <div className="block lg:hidden">
            <span className="absolute h-full items-center flex w-auto justify-end top-0 bottom-0 right-0 pr-4" style={{ zIndex: 250, paddingTop: isHomePage ? '1rem' : '0rem' }}>
                <MenuOutlined style={{ color: isHomePage ? 'white' : '#a98930', fontSize: '1.75rem' }} className="cursor-pointer p-2 rounded-md" onClick={onMobileMenuClick} />
            </span>
            {mobileMenuOpen ? (
                <div onClick={() => setMobileMenuOpen(false)} style={{ zIndex: 300, position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.3)' }}>
                    <div onClick={(e) => e.stopPropagation()} style={{ width: 'fit-content', maxHeight: '100dvh' }} className="shadow-lg bg-gslate border-r-solid text-gdeepcopper drop-shadow-lg py-7 pl-8 pr-12 flex flex-col gap-10 overflow-y-auto">
                        <div className="h-auto text-left flex flex-col gap-3">
                            <div className="flex flex-col gap-4 justify-center">
                                {
                                    siteMap?.map((page: any, i: number) => {
                                        let route = page.route?.toLowerCase() || "/";
                                        if (route === '/portfolio/jobs') {
                                            route = '/portfolio';
                                        }
                                        if (route.includes('/aboutus')) {
                                            route = route.replace('/aboutus', '/about');
                                        }
                                        if (route.includes('/contactus')) {
                                            route = route.replace('/contactus', '/contact');
                                        }
                                        return <div key={i} className="text-gcopper">
                                            <div>
                                                <a href={route}><h3 className="active:scale-95 font-united text-3xl">{page.name}</h3></a>
                                            </div>
                                            {
                                                page.children.length > 0
                                                    ? <div className="text-gconcrete py-3 flex flex-col gap-2">
                                                        {
                                                            page.children.map((c: any, i: number) => {
                                                                let route = c.route?.toLowerCase() || "/";
                                                                if (route.includes('/aboutus')) {
                                                                    route = route.replace('/aboutus', '/about');
                                                                }
                                                                if (route.includes('/ourteam')) {
                                                                    route = route.replace('/ourteam', '/team');
                                                                }
                                                                return <a key={c._id} href={route} className="active:scale-95 pl-3 font-roboto-condensed text-xl">{c.metaTitle}</a>;
                                                            })
                                                        }
                                                    </div> : null
                                            }
                                        </div>;
                                    })
                                }
                            </div>
                            <div className="text-gconcrete active:scale-105 pl-3 font-roboto-condensed text-xl"><a className="text-gconcrete" href="/contactus">Message Us</a></div>
                            <div className="text-gconcrete active:scale-105 pl-3 font-roboto-condensed text-xl"><a className="text-gconcrete" href="tel:+18554944832">+1 (855) 494-4832</a></div>
                        </div>
                        <div className="py-6">
                            {isInventory ? children : null}
                        </div>
                        <div style={{ height: 50 }} className="flex items-center gap-5 w-full justify-center mt-10">
                            <div className="flex h-full active:scale-105 text-facebook justify-center items-center"><a className="text-facebook" rel="me" href="https://www.facebook.com/profile.php?id=100074225224427" target="_blank"><i className="text-facebook flex fa-brands fa-facebook-f text-[1.75rem]"><FacebookOutlined /></i></a></div>
                            <div className="flex h-full active:scale-105 text-linkedin justify-center items-center"><a className="text-linkedin" rel="me" href="https://www.linkedin.com/company/gandpconstruction" target="_blank"><i className="flex fa-brands fa-linkedin-in text-[1.75rem]"><LinkedinOutlined /></i></a></div>
                            <div className="flex h-full active:scale-105 text-youtube justify-center items-center"><a className="youtube" rel="me" href="https://www.youtube.com/@gandpconstruction" target="_blank"><i className="flex fa-brands fa-youtube text-[1.75rem]"><YoutubeOutlined /></i></a></div>
                            <div className="flex h-full active:scale-105 text-instagram justify-center items-center"><a className="instagram" rel="me" href="https://www.instagram.com/gandpconstruction" target="_blank"><i className="flex fa-brands fa-instagram text-[1.75rem]"><InstagramOutlined /></i></a></div>
                        </div>

                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default MobileMenu;